import { render, staticRenderFns } from "./PrintEtichetaIDSterilizare.vue?vue&type=template&id=3aeb4246"
import script from "./PrintEtichetaIDSterilizare.vue?vue&type=script&lang=js"
export * from "./PrintEtichetaIDSterilizare.vue?vue&type=script&lang=js"
import style0 from "./PrintEtichetaIDSterilizare.vue?vue&type=style&index=0&id=3aeb4246&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports